// @flow

import React from 'react';

import { zoomTableActionsConfig } from '../../commons/zoomTable/zoomTableConfig';
import { RenderRetailTableActionButtons } from '../../commons/tableActionButton/tableActionButton';

import {
  getRetailTableCellObject,
  getCollectionsHandoverTableCellObject,
  roundOff
} from '../../../services/helpers';

export const retailCollectionsHandoverTableConfig = {
  columns: [
    {
      Header: 'User Details',
      headerClassName: 'flex-30',
      accessor: 'userName',
      className: 'table-cell-custom-retail flex-30',
      Cell: (row: Object) =>
        getRetailTableCellObject(
          row.original.userName,
          row.original.userMobile
        ),
      sortMethod: (a, b) => (a.toLowerCase() > b.toLowerCase() ? 1 : -1)
    },
    {
      Header: 'Pending',
      headerClassName: 'flex-25',
      className: 'table-cell-custom-retail flex-25',
      sortable: false,
      Cell: (row: Object) => {
        let total =
          roundOff(row.original.pendingCashAmount) +
          roundOff(row.original.pendingChequeAmount) +
          roundOff(row.original.pendingOnlineAmount) +
          roundOff(row.original.pendingWriteOffAmount) +
          roundOff(row.original.pendingSecurityDepositAmount) +
          roundOff(row.original.pendingBankTransferAmount);
        total = row.original.securityDepositAmount
          ? total + securityDepositAmount
          : total;
        return (
          <div>
            <div className="flex-20">&#8377;{roundOff(total)}</div>
          </div>
        );
      }
    },
    {
      Header: 'Pending Amount Breakdown',
      headerClassName: 'flex-25',
      className: 'table-cell-custom-retail flex-25',
      sortable: false,
      Cell: (row: Object) =>
        getCollectionsHandoverTableCellObject(
          roundOff(row.original.pendingCashAmount),
          roundOff(row.original.pendingChequeAmount),
          roundOff(row.original.pendingOnlineAmount),
          roundOff(row.original.pendingWriteOffAmount),
          roundOff(row.original.pendingSecurityDepositAmount),
          roundOff(row.original.pendingBankTransferAmount)
        )
    },
    {
      Header: 'Actions',
      headerClassName: 'flex-25',
      className: 'flex-25',
      width: 108,
      maxWidth: 108,
      sortable: false,
      Cell: (obj: Object) => (
        <RenderRetailTableActionButtons
          rowData={obj.original || {}}
          buttonConfig={zoomTableActionsConfig.RTL_COLLECTIONS_HANDOVER.buttons}
          modalTheme={{ width: '80%' }}
        />
      )
    }
  ],
  className: 'zoomTableLegacyWrapper',
  noDataText: 'No data found',
  minRows: 7,
  pageSizeOptions: [7, 10, 15, 25, 50, 100],
  style: { maxHeight: 'calc(100vh - 22rem)' }
};

export const retailCollectionsHandoverDateWiseConfig = {
  columns: [
    {
      Header: 'Date',
      headerClassName: 'flex-20',
      className: 'table-cell-custom-retail',
      accessor: 'date'
      // Cell: (row: Object) =>
      //   getRetailTableCellObject(row.original.userName, row.original.userMobile)
    },
    {
      Header: 'Total CNs',
      headerClassName: 'flex-20',
      className: 'table-cell-custom-retail',
      // accessor: "totalCNs"
      Cell: (row: Object) =>
        getRetailTableCellObject(
          `${row.original.totalCNs} CNs`,
          `${row.original.pendingCNs} Pending`
        )
    },
    {
      Header: 'Total Collection',
      headerClassName: 'flex-20',
      className: 'table-cell-custom-retail',
      accessor: 'totalCollections',
      Cell: (row: Object) =>
        roundOff(
          row.original.totalCashCollections +
            row.original.totalChequeCollections +
            row.original.totalSecurityDepositCollections,
          2
        )
    },
    {
      Header: 'Handover',
      headerClassName: 'flex-20',
      className: 'table-cell-custom-retail',
      accessor: 'handover',
      Cell: (row: Object) =>
        roundOff(
          row.original.handoveredCashAmount +
            row.original.handoveredChequeAmount +
            row.original.handoveredSecurityDepositAmount,
          2
        )
    },
    {
      Header: 'Pending',
      headerClassName: 'flex-20',
      className: 'table-cell-custom-retail',
      accessor: 'pending',
      Cell: (row: Object) =>
        roundOff(
          row.original.pendingCashAmount +
            row.original.pendingChequeAmount +
            row.original.pendingSecurityDepositAmount,
          2
        )
    },
    {
      Header: '',
      headerClassName: 'flex-20',
      sortable: false,
      Cell: (obj: Object) => {
        const totalPendingAmount = roundOff(
          obj.original.pendingCashAmount +
            obj.original.pendingChequeAmount +
            obj.original.pendingSecurityDepositAmount,
          2
        );
        return totalPendingAmount < 0 ? (
          <div className="cn-highlight" style={{ fontSize: '1.2rem' }}>
            Reverse handover not supported
          </div>
        ) : (
          <RenderRetailTableActionButtons
            rowData={obj.original || {}}
            modalTheme={{ name: 'actionButtonRetailDatewise' }}
            buttonConfig={
              zoomTableActionsConfig.RTL_COLLECTIONS_HANDOVER_DATE_WISE.buttons
            }
          />
        );
      }
    }
  ],
  className: 'zoomTableLegacyWrapper',
  noDataText: 'No handovers found',
  minRows: 7,
  pageSizeOptions: [7, 10, 15, 25, 50, 100],
  style: { maxHeight: '52rem' }
};

export const retailCollectionsHandoverTableActionsConfig = {
  buttons: [
    {
      label: 'View Details',
      onClick: rowData => {
        if (
          zoomTableActionsConfig.RTL_COLLECTIONS_HANDOVER.actions &&
          zoomTableActionsConfig.RTL_COLLECTIONS_HANDOVER.actions.showDetails
        ) {
          zoomTableActionsConfig.RTL_COLLECTIONS_HANDOVER.actions.showDetails(
            rowData
          );
        }
      }
    }
  ]
};

export const retailCollectionsHandoverDateWiseTableActionsConfig = {
  buttons: [
    {
      label: 'Initiate Handover',
      onClick: rowData => {
        if (
          zoomTableActionsConfig.RTL_COLLECTIONS_HANDOVER_DATE_WISE.actions &&
          zoomTableActionsConfig.RTL_COLLECTIONS_HANDOVER_DATE_WISE.actions
            .getCnWisePendingHandovers
        ) {
          zoomTableActionsConfig.RTL_COLLECTIONS_HANDOVER_DATE_WISE.actions.getCnWisePendingHandovers(
            rowData
          );
        }
      }
    }
  ]
};
